import axios from '../util/request'
import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()

// 登录
export const login = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.mobile}${data.sms_code}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/user/info/login', {
    params: { ...data }
  })
}

// 注册
export const register = (data) => {
  data.stamp = stamp
  data.opeid = ''
  console.log(`${data.mobile}${data.sms_code}${stamp}${atob(localStorage.getItem('okey'))}`)
  data.sign = md5(`${data.mobile}${data.sms_code}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/user/info/regUser', {
    params: { ...data }
  })
}

// 发送验证码
export const sendSms = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.mobile}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.get('/api/xiaosen/common/sendSmsCode', {
    params: { ...data }
  })
}

// 修改个人信息
export const editInfo = (data) => {
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  data.id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  data.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  data.stamp = stamp
  data.sign = md5(`${data.id}${stamp}${key}`)
  return axios.get('/api/xiaosen/user/info/info', {
    params: {...data}
  })
}

// 获取个人信息
export const getManage = () => {
  const key = localStorage.getItem('key') ? window.atob(localStorage.getItem('key')) : ''
  const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
  const sign = md5(`${stamp}${token}${user_id}${key}`)
  return axios.get('interface/getManage', {
    params: {
      user_id,
      token,
      stamp,
      sign
    }
  })
}